import { Storyboard, Layer, Timeline } from 'storyboard-renderer';

export class StoryboardVersion {
  timeline: Timeline;

  static mapFromStoryboard(storyboard: Storyboard): StoryboardVersion {
    return {
      timeline: storyboard.timeline
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/interface/story-board-version.ts